import React from "react";
import FlatCard from "./FlatCard";
import { classNames } from "components/utils";

export interface PaginationProps {
  currentPage: number;
  setCurrentPage: (page: number) => void;
  totalPages: number;
}

const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  setCurrentPage,
  totalPages,
}) => {
  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  return (
    <div className="flex justify-end mt-3 mr-5 items-center">
      <div onClick={handlePreviousPage} className="mr-3 mt-[2px]">
        <FlatCard
          noBorder={true}
          className={classNames(
            currentPage === 1 ? "hidden" : "cursor-pointer",
            "border border-gray-500 dark:border-zinc-800",
            "w-full flex items-center",
            "px-2 py-2",
            "text-xs",
            "h-7"
          )}
        >
          <span>Back</span>
        </FlatCard>
      </div>
      <span className="">{` Page ${currentPage} of ${totalPages} `}</span>
      <div onClick={handleNextPage} className="ml-3 mt-[2px]">
        <FlatCard
          noBorder={true}
          className={classNames(
            currentPage === totalPages ? "hidden" : "cursor-pointer",
            "border border-gray-500 dark:border-zinc-800",
            " w-full flex items-center",
            "px-2 py-2",
            "text-xs",
            "h-7"
          )}
        >
          <span>Next</span>
        </FlatCard>
      </div>
    </div>
  );
};

export default Pagination;
